import React, { useEffect, useState } from 'react'
import { heroImg, aurora, emoji, heroline,blueStar,lightStar,whiteStar } from '../../assets/images'
import styles from "./Hero.module.css"

interface Props{
  effect:string[];
}

const Hero = (props:Props) => {
const [index,setIndex]=useState(0)

const hello="Hello there, i enjoy creating pixel- perfect design solutions that are throughly backed by research and insights gotten from end users as well as also strategically positioning business goals and objectives."

// console.log(hello.length);
useEffect(()=>{

  setTimeout(()=>{
    setIndex(index+1)
  },20)

},[index])


  return (
    <section className='mt-[5.375rem]'>
      <div className='container md:pl-[60px] md:pr-[57px]  px-[20px]'>


        <div  className='md:flex justify-between relative'>
<img src={blueStar} className="absolute animateStar lg:top-[-10%] md:top-[-15%] top-[-10%] left-0 md:w-auto w-[4%]" alt="blue star" />
<img src={lightStar} className="absolute animateStar  top-[-10%] md:top-[-15%]  md:w-auto w-[3%] md:left-[20%] left-[30%]" alt="blue star" />
<img src={whiteStar} className="absolute animateStar  md:top-[70%] top-[40%] md:w-auto w-[3%] md:left-[40%] left-[95%]" alt="blue star" />

        <img src={heroline} className="absolute  lg:top-[-370px] md:top-[-400px] top-[-250px] xl:left-[-9%] lg:left-[-10%] md:left-[-10%] sm:left-[-25%] left-[-22%] sm:h-[519px]  h-[300px] w-[311px]  z-[-1]" alt="heroline" />
          <div className={`relative order-2 mx-auto md:w-[50%]  w-[70%] flex`}>

          <img src={heroline} className="absolute md:top-[-250px] top-[-190px] md:right-[-16%] lg:right-0 sm:right-[-15%] right-[-25%] sm:h-[519px]  h-[300px] w-[311px] z-[-1]" alt="heroline" />

            <img src={heroImg} data-aos={props.effect[1]} className="w-full" alt="heroImg" />

            <div className={`fadedCircle absolute top-0   translate-x-[-50%] left-[50%] z-[-1] bg-[#FE0000] rounded-full `}></div>

            <div className={`fadedCircle absolute top-[10%] z-[-1]  right-[0%] bg-[#FE0000] rounded-full `}></div>

            <div className={`circle absolute top-[60%] z-[-1]    right-[10%] bg-[#EF0BB3] rounded-full `}></div>

            <div className={`circle absolute top-[70%] z-[-1]   right-[50%] bg-[#3971E7] rounded-full `}></div>




          </div>

          <div data-aos={props.effect[0]} className='mt-[2.657rem]  md:p-0 flex-1 flex'>

            <div className='m-auto md:w-full w-[265px]'>

              <div className={`text-[1.179rem] inline-block lg:text-[2.25rem] md:text-left  text-center text-white`}>
                <p className={`${styles.greetHead}`}>Hi <img src={emoji} className="inline lg:w-[40px] w-[20.92px]" alt="" /> My name is Olaoluwa</p>
                <p className={`${styles.greetHead1}`}>and i’m a  <span className={`design bold text-[#A6B2EC]`}> Product Designer</span></p>
              </div>


              <p className={`text-[0.524rem]  md:w-[75%]  md:mt-[20px] p-2 sm:p-0  md:text-[1rem] md:text-left  leading-5 tracking-widest md:tracking-normal md:leading-6 text-center light text-white`}>
                {hello.slice(0,index)}
                   </p>

              <div className='flex md:justify-start relative md:mt-[46px] mt-[10px]  justify-center'>
                <button className='md:w-[223px] text-white  text-center md:h-[60px] h-[31.36px] w-[116.83px] md:text-[1rem]  bg-[#3971E7] text-[0.589rem] rounded-[5.24px] md:rounded-[10px]'>Hire me</button>

                <div className={`circle absolute top-[0%] z-[-1]  md:block hidden left-[20%] bg-[#3971E7] rounded-full `}></div>

              </div>

            </div>


          </div>
        </div>


      </div>

    </section>
  )
}

export default Hero


